import React, { useCallback, useState } from 'react';
import { IBaseActionPresentationProps } from '../../ActionPresentation';
import { useDropzone } from 'react-dropzone';
import { ZeroData } from 'azure-devops-ui/ZeroData';
import { Button } from 'azure-devops-ui/Button';
import './ScribePresentation.scss';
import { useCachingService } from '../../../hooks/useCachingService';
import { TextField, TextFieldStyle, TextFieldWidth } from 'azure-devops-ui/TextField';

export interface IScribePresentation extends IBaseActionPresentationProps {}

export const transcriptionKey = 'transcription';

export function ScribePresentation(props: IScribePresentation) {
  console.log('loading scribe presentation', props);
  const cache = useCachingService();
  const [fileContents, setFileContents] = useState<string | null>(null);
  const [stakeholders, setStakeholders] = useState<string | null>(null);
  const onDrop = useCallback((acceptedFiles: File[]) => {
    if (acceptedFiles.length == 0) return;

    const reader = new FileReader();

    reader.onabort = () => console.warn('file reading was aborted');
    reader.onerror = () => console.error('file reading has failed');
    reader.onload = () => {
      const contents = reader.result as string;
      setFileContents(contents);
      cache.setValue(transcriptionKey, buildTranscriptionContents(contents, stakeholders));
    };

    reader.readAsText(acceptedFiles[0]);
  }, []);
  const { acceptedFiles, fileRejections, getRootProps, getInputProps } = useDropzone({
    onDrop,
    maxFiles: 1,
    accept: {
      'text/vtt': [],
    },
  });

  const acceptedFileItems = acceptedFiles.map((file) => (
    <p>
      {file.name} - {file.size} bytes
    </p>
  ));

  function buildTranscriptionContents(transcription: string, stakeholders: string) {
    return `Stakeholders in the meeting: ${stakeholders}\r\n\r\n${transcription}`;
  }

  if (acceptedFileItems.length == 0) cache.clear(transcriptionKey);

  const filePicker = (
    <div className='flex-column flex-center'>
      <section className='container'>
        <div {...getRootProps({ className: 'dropzone' })} className='file-picker'>
          <input {...getInputProps()} />
          <p>Drag and drop the transcription or click to select files</p>
          <em>
            (Download your transcription from the Teams meeting in <code>.vtt</code> format)
          </em>
        </div>
        <aside>
          {acceptedFiles.length > 0 && (
            <p>
              {acceptedFiles[0].name} - {acceptedFiles[0].size} bytes
            </p>
          )}
        </aside>
      </section>

      <TextField
        prefixIconProps={{ iconName: 'UserFollowed' }}
        value={stakeholders}
        onChange={(e, newValue) => {
          setStakeholders(newValue);
          cache.setValue(
            transcriptionKey,
            buildTranscriptionContents(fileContents, newValue)
          );
        }}
        placeholder='Who were the main meeting participants? (name and role)'
        style={TextFieldStyle.inline}
        multiline
        rows={4}
        width={TextFieldWidth.standard}
        className='stakeholders'
        required={true}
      />

      <Button
        onClick={() => props.onStart()}
        disabled={acceptedFileItems.length == 0 || !fileContents || !stakeholders}
        primary={true}
        className='start-button'
      >
        Start
      </Button>
    </div>
  );

  return (
    <div className='centered-zero-data'>
      <ZeroData
        primaryText={props.name}
        secondaryText={props.description}
        imageAltText='Brain'
        imagePath={require(`../../../img/${props.imageName}`)}
        renderAction={() => filePicker}
      />
    </div>
  );
}
